export const senderSelectionGermanLocalization = {
  selectionSheet: {
    title: 'Absender wählen',
    personalProfile: 'Persönliches Profil'
  }
};

// Guarantees that both translations have the same structure
type SenderSelectionLocalization = typeof senderSelectionGermanLocalization;

export const senderSelectionEnglishLocalization: SenderSelectionLocalization = {
  selectionSheet: {
    title: 'Choose sender',
    personalProfile: 'Personal profile'
  }
};
